var map = {
	"./brands.json": [
		678,
		744
	],
	"./custom-icons.json": [
		679,
		745
	],
	"./full-color.json": [
		680,
		746
	],
	"./light.json": [
		681,
		747
	],
	"./solid.json": [
		682,
		748
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 666;
module.exports = webpackAsyncContext;